import defaultData from "./defaultData.js";
//前缀地址
const STORAGE_PRE = "ao_20230607_v2_";
const storage = {
    defaultData: defaultData.defaultData,
    STORAGE_PRE,
    /**
   * 设置storage
   * @param [key] 设置的名称。
   * @param [value] 设置的内容。
   */
    setStorage: function(key, value) {
        if (key instanceof Object) {
            for (var k in key) {
                var curTime = new Date().getTime();
                localStorage.setItem(this.STORAGE_PRE + k, JSON.stringify({
                    data: key["" + k],
                    time: curTime
                }));
                if (this.defaultData.hasOwnProperty(k)) {
                    this.defaultData[k] = key["" + k];
                }
                this.defaultData[k] = key["" + k];
            }
            return;
        }
        var curTime = new Date().getTime();
        localStorage.setItem(this.STORAGE_PRE + key, JSON.stringify({
            data: value,
            time: curTime
        }));

        if (this.defaultData.hasOwnProperty(key)) {
            this.defaultData[key] = value;
        }
        return value;
    },
    /**
   * 获取Storage
   * @param [key] 获取的名称。
   * @param [day] 超过过期的天数
   */
    getStorage: function(key, day = 3) {
        var data = localStorage.getItem(this.STORAGE_PRE + key);
        if (data) {
            var dataObj = JSON.parse(data);
            if (new Date().getTime() - dataObj.time > 1000 * 60 * 60 * 24 * day) {
                return false;
            } else {
                var dataObjDatatoJson = dataObj.data;
                return dataObjDatatoJson;
            }
        } else {
            return false;
        }
    },
    /**
   * 删除Storage
   * @param [key] 删除的名称。
   */
    removeStorage: function(key) {
        if (key instanceof Array) {
            for (var i = 0; i < key.length; i++) {
                localStorage.removeItem(this.STORAGE_PRE + key[i]);
                if (this.defaultData.hasOwnProperty(key[i])) {
                    this.defaultData[key[i]] = "";
                }
            }
            return false;
        }
        localStorage.removeItem(this.STORAGE_PRE + key);
    },
    /**
   * 获取默认默认值
   */
    getDefaultData() {
        //
        for (let item in this.defaultData) {
            // source的不做更改不然所有接口会有跨域问题
            if (item != 'source') {
                this.defaultData[item] = this.getStorage(item);
            }
        }
        let inviteuid = this.getStorage("inviteuid", 30); // 判断有没有超过30天
        this.defaultData.inviteuid = inviteuid ? inviteuid : "";
    }
}

export default storage;
